import React from "react";
import ConferenceTalk from "./Conference/ConferenceTalk";
import InvitedTalk from "./Conference/InvitedTalk";
import SideBar from "./SideBar";

const Conference = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar conference = {true}/>
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5"> Invited Talks and Conference Talks </div>
          <hr />
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                className="nav-item nav-link active"
                id="nav-conferenceTalks-tab"
                data-bs-toggle="tab"
                href="#nav-conferenceTalks"
                role="tab"
                aria-controls="nav-conferenceTalks"
                aria-selected="false"
              >
                Conference Talks
              </a>
              <a
                className="nav-item nav-link"
                id="nav-invitedTalks-tab"
                data-bs-toggle="tab"
                href="#nav-invitedTalks"
                role="tab"
                aria-controls="nav-invitedTalks"
                aria-selected="true"
              >
                Invited Talks
              </a>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade"
              id="nav-invitedTalks"
              role="tabpanel"
              aria-labelledby="nav-invitedTalks-tab"
            >
              <div className="my-4">
                <InvitedTalk />
              </div>
            </div>
            <div
              className="tab-pane fade show active"
              id="nav-conferenceTalks"
              role="tabpanel"
              aria-labelledby="nav-conferenceTalks-tab"
            >
              <div className="my-4">
                <ConferenceTalk />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Conference;
